import { mergeMap } from 'rxjs';

import { Injectable } from '@angular/core';
import {
	addEntities,
	deleteEntities,
	getActiveId,
	getEntity,
	getEntityByPredicate,
	selectEntity,
	selectEntityByPredicate,
	selectMany,
	updateEntities,
} from '@ngneat/elf-entities';

import { BaseRepository } from '../base.repository';
import { ManifestsRepository } from './manifests.repository';
import { guestsEntitiesRef, Product, productsEntitiesRef, store } from './manifests.store';

@Injectable({ providedIn: 'root' })
export class ProductsRepository extends BaseRepository {
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(private manifestRepo: ManifestsRepository) {
		super();
	}

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - store
	 **-------------------------------------------------------------------------------------
	 */
	get store() {
		return store;
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - getActiveProduct
	 **-------------------------------------------------------------------------------------
	 */
	getActiveProduct = () => {
		const { activeProductId } = this.manifestRepo.getActiveManifest();
		return store.query(getEntity(activeProductId, { ref: productsEntitiesRef }));
	};
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	products$ = () => {
		const { products } = this.manifestRepo.getActiveManifest();
		return store.pipe(selectMany(products, { ref: productsEntitiesRef }));
	};
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	productsByManifest = () => {
		const { products } = this.manifestRepo.getActiveManifest();
		return store.query(getEntityByPredicate(e => products.includes(e.id), { ref: productsEntitiesRef }));
	};
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	products = (): number[] => {
		const { products } = this.manifestRepo.getActiveManifest();
		return products;
	};
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	product = (id): Product => {
		return store.query(getEntity(id, { ref: productsEntitiesRef }));
	};
	/*
	 **----------------------------------------------------------------------------------------------------------------------------------------------
	 ** METHOD NAME - getProdductByGuest
	 **----------------------------------------------------------------------------------------------------------------------------------------------
	 */
	getProductByGuest = guestId => {
		const { products } = this.manifestRepo.getActiveManifest();
		return store.query(getEntityByPredicate(e => products.includes(e.id) && e.manifestGuests.includes(guestId), { ref: productsEntitiesRef }));
	};
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	selectProductGuests$ = productId => {
		return store
			.pipe(selectEntity(productId, { ref: productsEntitiesRef }))
			.pipe(mergeMap(product => store.pipe(selectMany(product?.manifestGuests || [], { ref: guestsEntitiesRef }))));
	};
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */

	product$ = productId =>
		store.pipe(
			selectEntityByPredicate(({ id }) => id === productId, {
				ref: productsEntitiesRef,
			})
		);

	//queres
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	activeId = () => store.query(getActiveId);

	//mutations
	setActiveProduct = id => {
		const manifestId = this.activeId();
		store.update(updateEntities(manifestId, { activeProductId: id }));
	};
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	addProduct = (product: Product) => store.update(addEntities(product, { ref: productsEntitiesRef }));
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	updateProduct = (id: number, product: Partial<Product>) => store.update(updateEntities(id, { ...product }, { ref: productsEntitiesRef }));

	/*
	 **----------------------------------------------------------------------------------------------------------------------------------------------
	 ** METHOD NAME - removeProduct
	 **----------------------------------------------------------------------------------------------------------------------------------------------
	 */
	public removeProduct(id) {
		store.update(deleteEntities(id, { ref: productsEntitiesRef }));
	}
}
